import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { HANDSTYLE } from "../lib/brand";
import Seo, { usePageSeo } from "../lib/seo";

export default function About() {
  const pageSeo = usePageSeo("about");
  return (
    <main data-testid="about-page" className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 pt-40 md:pt-56 pb-24">
      <Seo title={pageSeo?.seo_title} description={pageSeo?.seo_description}
        canonical={`${window.location.origin}/about`} />
      <div className="md:grid md:grid-cols-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
          className="md:col-span-8 md:col-start-2 lg:col-span-6 lg:col-start-2 max-w-[640px]"
        >
          <div className="label" data-testid="about-label">About</div>

          <h1
            className="font-display font-500 tracking-[-0.01em] leading-[1.18] mt-16 md:mt-24"
            style={{ fontSize: "clamp(1.75rem, 3.6vw, 3rem)" }}
            data-testid="about-opening"
          >
            RCKT began with a decision to listen more and speak less.
          </h1>

          <p className="font-display font-400 text-xl md:text-2xl leading-snug text-[var(--muted)] mt-24 md:mt-36" data-testid="about-secondary">
            The more I listened, the quieter I became.
          </p>

          <div className="mt-24 md:mt-36 space-y-7 text-base md:text-lg leading-[1.8]" data-testid="about-body">
            <p>
              In that quiet, I began to understand that we are all, in some way, broken, and that we move
              through lives defined by imperfection. We can encounter the same moment, the same circumstance,
              the same truth, and still walk away carrying something entirely different.
            </p>
            <p>
              Our perspectives are shaped by the biases we inherit, the prejudices we carry, and the values and
              principles we choose to live by. What we see, what we understand, and what we take from the world
              are ultimately our own.
            </p>
          </div>

          <p className="font-display font-500 text-2xl md:text-3xl leading-[1.25] mt-28 md:mt-44" data-testid="about-closing">
            I am RCKT.<br />This is my artistic practice.
          </p>

          <div className="mt-20 md:mt-28" data-testid="about-signature">
            <img src={HANDSTYLE} alt="RCKT signature" className="h-20 md:h-28 lg:h-32 w-auto" />
          </div>

          <div className="mt-28 md:mt-44">
            <Link
              to="/archive"
              data-testid="about-enter-archive"
              className="group inline-flex items-center gap-3 font-display uppercase tracking-[0.12em] text-sm"
            >
              <span className="border-b border-transparent group-hover:border-[var(--ink)] transition-colors pb-1">
                Enter the Archive
              </span>
              <span className="transition-transform duration-300 group-hover:translate-x-1.5">→</span>
            </Link>
          </div>
        </motion.div>
      </div>
    </main>
  );
}
